import { Injectable } from "@angular/core";
import { Subject } from "rxjs";
import { HttpclientService } from "../../../../../shared";
import { ChatLogInsertRequest } from "./info/chat-log-insert-request";

@Injectable()
export class DataService_SupportChatWindow {
	constructor(private httpclientService: HttpclientService) {}

	ChatLogInsert(parms: ChatLogInsertRequest) {
		var postResult$ = new Subject();
		var url = "SupportChat/ChatLogInsert";
		var promise$ = this.httpclientService.post(url, parms);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}

	ChatLogSelectList() {
		var postResult$ = new Subject();
		var url = "SupportChat/ChatLogSelectList?";
		var promise$ = this.httpclientService.post(url, null);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}

	ChatLogClear() {
		var postResult$ = new Subject();
		var url = "SupportChat/ChatLogClear?";
		var promise$ = this.httpclientService.post(url, null);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}
}
